
// Utilities
import { getParentGeoId, useFetchWrapper, useHandleError } from '../helpers';
import { APIS } from '../constants';
import { errorState, selectedGeoDropdownState } from '../states';
import { useRecoilValue, useSetRecoilState } from 'recoil';



const useDashboardService = () => {
    const fetchWrapper = useFetchWrapper();
    const { getErrorMsg } = useHandleError();
    const setError = useSetRecoilState(errorState);
    const selectedGeoDropdown = useRecoilValue(selectedGeoDropdownState);

    const getBarGraphData = (geoCode: any, selectedGeo:any, selTab:number, selectedPoi: string[]) => {
            const {parent} = getParentGeoId(geoCode, selectedGeo, selTab, )
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_BAR_GRAPH}?geoId=${geoCode}&parentgeoId=${parent}&poi=${selectedPoi}`)
    };

    const getTreeMapData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_TREE_MAP, payload);
    };

    const getBreakdownTableData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_BREAKDOWN_TABLE_DATA, payload)
    }

    const getSelectedTreeMapData = (geoCode: any, categoryId: any, parentid?: number) => {
        if (selectedGeoDropdown?.geotype === "pincode") {
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_TREE_MAP_FOR_SELECTED_CATEGORY}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}&type="pincode"`);
        }
        else {
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_TREE_MAP_FOR_SELECTED_CATEGORY}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}`)
        }
    };

    const getHighlightsData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_HIGHLIGHTS_FOR_ALL_CATEGORIES, payload);
    };

    const getkpivalues = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_KPI_VALUES, payload);
    }

    const getGrowthInTimePoiData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHINTIME_POIDATA, payload);
    }

    const getSelectedCategoryHighlights = (geoCode: any, categoryId: any, parentid?: number) => {
            if (selectedGeoDropdown?.geotype === "pincode") {
                return fetchWrapper.get(`${APIS.DASHBOARD.GET_DEEP_DIVE_HIGHLIGHTS}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}&type="pincode"`);
        }
        else {
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_DEEP_DIVE_HIGHLIGHTS}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}`);
        }

    }

    const getGrowthInTimePoiDataByCategory = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHINTIME_POIDATA_BY_CATEGORY, payload);
    }
    const requestDownloadData = async (payload: any) => {
        try {
            const response = await fetchWrapper.post(APIS.DASHBOARD.REQUEST_DOWNLOAD_DATA, payload);
            if (response) {
                setError({ type: 'Data Requested', message: response.detail });
            }
        } catch (error) {
            getErrorMsg(error);
        }
    }

    const getGrowthInTimePoiDataBySubcategory = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHINTIME_POIDATA_BY_SUBCATEGORY, payload);
    }
    const getGrowthRateAllSubCategories = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHRATE_ALL_SUBCATEGORIES, payload);
    }

    const getFilteredHighlights = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_FILTERED_HIGHLIGHTS, payload);
    }

    const getPresencedetails = (geoCode: any) => {
        return fetchWrapper.get(`${APIS.DASHBOARD.GET_PRESENCE_DETAILS}?geoId=${geoCode}`);
    }

    const getFilteredDropdown = (geoCode: any) => {
        return fetchWrapper.get(`${APIS.DASHBOARD.GET_FILTERED_DROPDOWN}?geoId=${geoCode}`);
    }

    const getMBPTableData = (geoCode: any, param: string, paramclass: string) => {
        return fetchWrapper.get(`${APIS.DASHBOARD.GET_MBP_TABLE_DATA}?geoId=${geoCode}&param=${param}&paramclass=${paramclass}`)
    }

    const getMBPGraphData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_MBP_GRAPH_DATA, payload);
    }

    return {
        getBarGraphData,
        getBreakdownTableData,
        getTreeMapData,
        getSelectedTreeMapData,
        getHighlightsData,
        getkpivalues,
        getGrowthInTimePoiData,
        getSelectedCategoryHighlights,
        getGrowthInTimePoiDataByCategory,
        getGrowthInTimePoiDataBySubcategory,
        getGrowthRateAllSubCategories,
        requestDownloadData,
        getFilteredHighlights,
        getPresencedetails,
        getFilteredDropdown,
        getMBPTableData,
        getMBPGraphData,
    }
}

export { useDashboardService };